import { Component, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeAdDetails,
  invokeCreateAdvertisingCampaignByLocation,
  SetAddAdvertisingCampaign,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AdDetailsInterface } from "src/app/shared/models/advertising-campaigns/ad-details.interface";
import { addCampaignSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { JwtService } from "src/app/shared/services/jwt.service";
import { ToastrService } from "ngx-toastr";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { LocationWithAvailabilities } from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { Router } from "@angular/router";
import {
  catchForbiddenErrorSelector,
  catchServerErrorSelector,
} from "src/app/store/user/user.selectors";
import {
  catchForbiddenError,
  catchServerError,
} from "src/app/store/user/user.actions";
import { RoleOptionEnum } from "src/app/shared/enum/roleOptionEnum";

@Component({
  selector: "app-promote",
  templateUrl: "./promote.component.html",
})
export class PromoteComponent extends BaseComponent implements OnInit {
  created$: Observable<SuccessDto | null>;
  companyName: string;
  filename: string | null;
  submitted: boolean = false;
  campaignLP: any;
  showProgress: boolean = false;
  uploadProgress: number = 0;
  files: File[] = [];

  bookMeeting: string;
  loading: boolean;
  locationWithAvailabilities: LocationWithAvailabilities;

  ad: AdDetailsInterface;
  catchServerError$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;
  constructor(
    private store: Store<AppStateInterface>,
    private toastr: ToastrService,
    private jwtService: JwtService,
    private translate: TranslateService,
    private saveHistory: SaveUserHistoryService,
    private router: Router
  ) {
    super(store);
    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.created$ = this.store
      .pipe(select(addCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }
  ngOnInit(): void {
    this.catchServerError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.store.dispatch(catchServerError({ serverError: null }));
      }
    });
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.bookMeeting = environment.links.bookMeetingLP;
    this.companyName = this.jwtService.getCompanyName();
    this.created$.subscribe((created: SuccessDto | null) => {
      if (created != null) {
        this.loading = false;
        this.toastr.success(
          this.translate.instant("response.success." + created.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(SetAddAdvertisingCampaign({ adCreated: null }));
        this.store.dispatch(
          invokeAdDetails({ invokeAdDetails: { ...this.ad, videoFile: null } })
        );
        this.filename = null;
        this.submitted = false;
        this.router.navigate(["dashboard/location-partner/LPCampaigns"]);
      }
    });

    /// To clear the video store when returning to the Promote page
    this.store.dispatch(
      invokeAdDetails({ invokeAdDetails: { ...this.ad, videoFile: null } })
    );
  }

  catchFileName(name: string | null) {
    this.filename = name;
  }

  onSubmit() {
    this.loading = true;
    this.store.dispatch(
      invokeCreateAdvertisingCampaignByLocation({
        campaignDto: {
          title: UtilFunctions.replaceSpacesWithHyphen(this.companyName),
          locationPartners: [this.companyName],
          videoLink: this.filename,
          franchiseCompanyName: null,
          optionEnum: RoleOptionEnum.LOCATION_PARTNER,
        },
      })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.POST,
      UserHistoryServicesEnum.PROMOTE_CAMPAIGN_LP
    );
  }
}
